import { createSlice, SliceCaseReducers } from "@reduxjs/toolkit";

import { PartType, Stock } from "operations/schema/schema";
import { RootState } from "store";
import { asyncQueries, queryBuilder } from "./stock.queries";

export interface State {
  stockEnquiry: PartType[];
  stockList: Stock[];
  loadingStockEnquiry: boolean;
}

interface Reducers extends SliceCaseReducers<State> {}

interface Selectors {
  selectStockList: (state: RootState) => Stock[];
}

export const initialState: State = {
  stockEnquiry: [],
  stockList: [],
  loadingStockEnquiry: false,
};

const reducers: Reducers = {};

const selectors: Selectors = {
  selectStockList({ stock: { stockList } }) {
    return stockList;
  },
};

const storeBase = createSlice<State, Reducers>({
  name: "stock",
  initialState,
  reducers,
  extraReducers: queryBuilder,
});

export default storeBase.reducer;
export const { selectStockList } = selectors;
export const { getStockEnquiry, getStockList } = asyncQueries;
